export const JOB_TEMPLATE_OPTIONS = [
  {
    label: 'Cashier',
    value: 'CASHIER',
  },
  {
    label: 'CDL A Driver',
    value: 'CDL_A_DRIVER',
  },
  {
    label: 'Crew Leader',
    value: 'CREW_LEADER',
  },
  {
    label: 'Delivery Truck Driver',
    value: 'DELIVERY_TRUCK_DRIVER',
  },
  {
    label: 'Dishwasher',
    value: 'DISHWASHER',
  },
  {
    label: 'General Mechanic',
    value: 'GENERAL_MECHANIC',
  },
  {
    label: 'Landscaping Laborer',
    value: 'LANDSCAPING_LABORER',
  },
  {
    label: 'Warehouse Worker',
    value: 'WAREHOUSE_WORKER',
  },
];
